import { useDispatch, useSelector } from "react-redux";
// import Link from "next/link";
import Router, { useRouter } from "next/router";
import { NotificationManager } from "react-notifications";
// import { useEffect, useState } from "react";

import { logout } from "../store/actions/auth";
// import axiosInstance from "../config/axios";
import { setRecentOrders } from "../store/actions/shop";
import { useState, useEffect } from "react";
import { addToCart, setTotalPrice } from "../store/actions/shop";
import axiosInstance from "../config/axios";

const Nav = ({ orderingTime, deliveryOrderingTime }) => {
  const allCart = useSelector((state) => state.shop.cart);
  const allTotalPrice = useSelector((state) => state.shop.totalPrice);
  const [showCart, setShowCart] = useState(false);
  const [productCart, setProductCart] = useState(allCart);
  const [minOrderAmount, setMinOrderAmount] = useState(null);

  const toggleCart = () => {
    setShowCart((prev) => !prev);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchMinPrice = async () => {
        try {
          const {
            data: { data: res },
          } = await axiosInstance.get("settings/get-min-order-amount");

          setMinOrderAmount(Number(res.min_order_amount));
        } catch (e) {
          // console.log(e);
        }
      };

      fetchMinPrice();
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const testauth = useSelector((state) => state.auth);
  let user = useSelector((state) => state.auth.user) || {};
  let token = useSelector((state) => state.auth.token);
  //console.log("testingAuth", testauth);

  const dispatch = useDispatch();
  const router = useRouter();
  const currentPath = router.pathname;

  const logoutHandler = () => {
    dispatch(logout(token));
    !loggedIn ? null : NotificationManager.success("Logged out", "", 3000);
    dispatch(setRecentOrders([]));
    if (router.pathname.includes("/wallet")) {
      Router.push("/signup");
    }
    if (
      router.pathname.includes("/profile") ||
      router.pathname.includes("/orders")
    ) {
      Router.push("/");
    }
  };

  const signupHandle = () => {
    localStorage.removeItem("checkoutToLogin");
  };

  const showClosed = () => {
    if (orderingTime.orderingTime === false) {
      // $('#storeClosed').modal('show');
      return;
    } else {
      Router.push("/");
      return;
    }
  };

  const updateQuantityHandle = (cartIndex, action) => {
    const cartCopy = [...allCart];
    const price = cartCopy[cartIndex].salePrice || cartCopy[cartIndex].price;

    // increment or decrement
    if (action === "increment") {
      cartCopy[cartIndex].quantity += 1;
    } else if (action === "decrement" && cartCopy[cartIndex].quantity > 1) {
      cartCopy[cartIndex].quantity -= 1;
    }

    // recalculate total
    cartCopy[cartIndex].totalPrice = cartCopy[cartIndex].quantity * price;

    // update state + redux
    setProductCart(cartCopy);
    dispatch(addToCart(cartCopy));
    dispatch(setTotalPrice());
  };
  const deleteProductCartHandler = (index, id) => {
    const cartSlice = [...allCart];
    cartSlice.splice(index, 1);
    //setProductCart(cartSlice);
    dispatch(addToCart(cartSlice));
    dispatch(setTotalPrice());
  };
  const totalSum = allCart.reduce((sum, item) => sum + item.totalPrice, 0);

  return (
    <>
      <style jsx>{`
        .active-link .nav-link {
          border-bottom: 2px solid white;
        }
        .cart-badge {
          position: absolute;
          top: -7px;
          left: 30px;
          color: #fff;
          padding: 2px 6px;
          background: transparent;
          font-size: 1.75rem;
          font-weight: bold;
          line-height: 1;
          min-width: 18px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        @media (max-width: 991px) {
          .mobile-cart {
            order: -1;
          }
        }
      `}</style>

      <div className="d-flex align-items-center d-lg-none"></div>

      {/* Desktop nav — cart stays here too for desktop */}
      <div
        className="navbar-collapse ml-auto collapse"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav mt-md-0 mt-4 mb-sm-0 mb-4">
          <li
            className={`nav-item nav-hover ${currentPath === "/" ? "active-link" : ""}`}
          >
            <a
              onClick={showClosed}
              className="nav-link order-now-link"
              href="/"
            >
              Order
            </a>
          </li>
          <li
            className={`nav-item nav-hover ${currentPath === "/store-location" ? "active-link" : ""}`}
          >
            <a className="nav-link" href="/store-location">
              Locations
            </a>
          </li>
          <li
            className={`nav-item nav-hover ${currentPath === "/wallet" ? "active-link" : ""}`}
          >
            <a className="nav-link" href="/wallet">
              Wallet
            </a>
          </li>
          <li
            className={`nav-item nav-hover ${currentPath === "/giftcard" ? "active-link" : ""}`}
          >
            <a className="nav-link" href="/giftcard">
              Giftcard
            </a>
          </li>
          <li
            className={`nav-item nav-hover ${currentPath === "/blog" ? "active-link" : ""}`}
          >
            <a className="nav-link" href="/blog">
              Blog
            </a>
          </li>

          {/* Cart — desktop only inside hamburger */}
          <li className="nav-item position-relative d-none d-lg-block">
            <a className="nav-link p-0 position-relative" onClick={toggleCart}>
              <img
                src="/images/icon/new-cart.svg"
                alt="cart-logo"
                width={40}
                height={35}
                style={{ cursor: "pointer" }}
              />
              <span className="cart-badge">{allCart.length}</span>
            </a>

            {showCart && (
              <section>
                <div className="cart-dropdown p-3 bg-white border rounded shadow-sm">
                  <div className="d-flex justify-content-between align-items-center mb-2 border-bottom">
                    <h6 className="m-2 text-center flex-grow-1">Cart</h6>
                    <span
                      className="close text-muted mb-2"
                      style={{ cursor: "pointer", fontSize: "2.5rem" }}
                      onClick={() => setShowCart(false)}
                    >
                      &times;
                    </span>
                  </div>

                  <div className="cart-items-wrapper">
                    {!allCart.length > 0 ||
                      (allTotalPrice < minOrderAmount && (
                        <p className="mb-2">
                          A minimum order of ₦{minOrderAmount.toLocaleString()}{" "}
                          is required. Current total: ₦
                          {allTotalPrice === null
                            ? "0"
                            : allTotalPrice.toLocaleString()}
                        </p>
                      ))}
                    {allCart.length > 0 ? (
                      <>
                        {allCart.map((cart, index) => (
                          <div
                            className="cart-items mb-3 w-100"
                            key={`Prod-cart${cart?.product.id || index}`}
                          >
                            <div className="d-flex justify-content-between">
                              <div className="d-flex">
                                <img
                                  src={cart.product?.image_url}
                                  alt={cart.product.product}
                                  className="mr-3"
                                  width={30}
                                  height={30}
                                />
                                <p>{cart?.product?.product}</p>
                              </div>
                              <p>{"₦" + cart?.totalPrice?.toLocaleString()}</p>
                            </div>

                            <div className="d-flex justify-content-between mt-2">
                              <div>
                                <span
                                  className="increment mr-3"
                                  onClick={() =>
                                    updateQuantityHandle(index, "decrement")
                                  }
                                >
                                  –
                                </span>
                                <span className="font-weight-bold mr-3">
                                  {cart.quantity}
                                </span>
                                <span
                                  className="increment"
                                  onClick={() =>
                                    updateQuantityHandle(index, "increment")
                                  }
                                >
                                  ＋
                                </span>
                              </div>
                              <a>
                                <i
                                  className="fa fa-trash"
                                  style={{ color: "#DC042A", fontSize: "20px" }}
                                  onClick={() =>
                                    deleteProductCartHandler(
                                      index,
                                      cart.product.id,
                                    )
                                  }
                                />
                              </a>
                            </div>
                          </div>
                        ))}

                        <div className="d-flex justify-content-between mb-3">
                          <p className="font-weight-bold">Subtotal</p>
                          <p className="h4 font-weight-bold mr-0">
                            {"₦" + new Intl.NumberFormat().format(totalSum)}
                          </p>
                        </div>

                        <div className="d-flex flex-md-row flex-column justify-content-between">
                          <button
                            className="btn w-100 mb-2 mb-md-0 mr-md-2"
                            onClick={() => {
                              setShowCart(false);
                              Router.push("/cart");
                            }}
                          >
                            <span
                              className="text"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              View or Edit
                            </span>
                          </button>
                          <button
                            className="btn w-100 w-md-auto"
                            onClick={() => {
                              setShowCart(false);
                              Router.push("/checkout");
                            }}
                            disabled={allTotalPrice < minOrderAmount}
                          >
                            <span
                              className="text"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Proceed to Checkout
                            </span>
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p className="empty-text mb-3 mt-4 text-center">
                          Your cart is empty
                        </p>
                        <button
                          className="btn w-100 w-md-auto"
                          onClick={() => {
                            setShowCart(false);
                            Router.push("/");
                          }}
                        >
                          <span
                            className="text"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Continue shopping
                          </span>
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </section>
            )}
          </li>

          {!loggedIn ? (
            <li onClick={signupHandle} className="nav-item nav-bg-white">
              <a className="nav-link" href="/signup">
                Sign Up/Login
              </a>
            </li>
          ) : null}

          {loggedIn && (
            <div className="nav-item nav-bg-white account-toggle">
              <a className="dropdown-toggle" data-toggle="dropdown">
                {`${user?.first_name}`}
              </a>
              <div className="dropdown-menu">
                <a className="dropdown-item" href="/orders">
                  My Orders
                </a>
                <a className="dropdown-item" href="/profile">
                  Profile
                </a>
                <a href="#" onClick={logoutHandler} className="dropdown-item">
                  Log out
                </a>
              </div>
            </div>
          )}
        </ul>
      </div>
    </>
  );
};

export default Nav;
